import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { formatErr } from "@/lib/api";
import { useCompany } from "@/config";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const company = useCompany();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Passwords do not match");
    if (pw.length < 6) return toast.error("Password must be at least 6 characters");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated. Please sign in.");
      nav("/login");
    } catch (err) { toast.error(formatErr(err)); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-[#F7F7F5]" data-testid="reset-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-[#E5E5E5] p-8 lg:p-10">
        <div className="flex items-center gap-3 mb-6">
          <img src={company.brand.logo} alt={company.shortName} className="h-10 w-10 object-contain" />
          <div className="font-head font-bold text-xl tracking-tighter">{company.shortName}</div>
        </div>
        <div className="eyebrow mb-3">Choose new password</div>
        <h2 className="font-head text-3xl font-bold tracking-tighter mb-8">Reset password</h2>
        {!token ? (
          <div className="p-4 border border-red-200 bg-red-50 text-red-700 text-sm">
            Invalid reset link. Request a new one <Link to="/forgot-password" className="underline">here</Link>.
          </div>
        ) : (
          <div className="space-y-5">
            <div>
              <Label className="eyebrow">New password</Label>
              <Input type="password" required value={pw} onChange={(e) => setPw(e.target.value)}
                className="mt-2 rounded-none border-[#E5E5E5] h-11" data-testid="reset-pw" />
            </div>
            <div>
              <Label className="eyebrow">Confirm password</Label>
              <Input type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)}
                className="mt-2 rounded-none border-[#E5E5E5] h-11" data-testid="reset-pw2" />
            </div>
            <Button type="submit" disabled={busy} data-testid="reset-submit"
              className="w-full h-12 rounded-none bg-[#FF5500] hover:bg-[#E64D00] text-white font-semibold">
              {busy ? "Updating..." : "Update password"}
            </Button>
          </div>
        )}
      </form>
    </div>
  );
}
